import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StyleManagerService {
  /**
   * Load the stylesheet with the specified key and wait until it is applied.
   * @param key Stylesheet identifier
   * @param href Stylesheet URL
   */
  setStyle(key: string, href: string): Promise<void> {
    return new Promise(resolve => {
      const className = getClassNameForKey(key);
      const existing = document.head.querySelector(`link.${className}`) as HTMLLinkElement | null;

      if (existing?.href.endsWith(href)) {
        resolve();
        return;
      }

      existing?.remove();

      const linkEl = document.createElement('link');
      linkEl.setAttribute('rel', 'stylesheet');
      linkEl.classList.add(className);
      linkEl.href = href;

      const done = (): void => resolve();
      linkEl.addEventListener('load', done, { once: true });
      linkEl.addEventListener('error', done, { once: true });
      document.head.appendChild(linkEl);
      setTimeout(done, 500);
    });
  }
}

function getClassNameForKey(key: string): string {
  return `app-${key}`;
}
